import { NgModule } from "@angular/core";
import {
  HTTP_INTERCEPTORS,
  HttpClientModule,
  HttpBackend,
  HttpClient,
} from "@angular/common/http";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ToastrModule } from "ng6-toastr-notifications";
import { TabsModule } from "ngx-bootstrap/tabs";
import { LocalStorageService } from "../core/local-storage.service";
import { HttpInterceptorService } from "../core/http-interceptor.service";

import {
  CalendarModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  DataTableModule,
  MessageService,
  GMapModule,
} from "primeng/primeng";
import { TableModule } from "primeng/table";
import { DialogModule } from "primeng/dialog";
import { ChartModule } from "primeng/chart";
import { PaginatorModule } from "../core/paginator/paginator";
import { PaginationService } from "./pagination.service";
import { AuthGuard } from "../core/auth.guard";
import { CommonModule } from "@angular/common";
import { DatePipe } from "@angular/common";
import { NumberDirective } from "./directive/number.directive";
import { DecimalDirective } from "./directive/decimal.directive";
import { ControlPasteDirective } from "./directive/control-paste.directive";
import { CurrencySymbolPipe } from "./pipe/currency.pipe";
import { AgmCoreModule } from "@agm/core";
import { AgmDirectionModule } from "agm-direction";
import { TooltipModule } from "primeng/tooltip";
import { ChipsModule } from "primeng/chips";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerModule } from "ngx-spinner";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,
} from "@coreui/angular";
import { UserPermissionComponent } from "./user-permission/user-permission.component";
import { P403Component } from "../views/error/403/403.component";
import { LanguageTranslatorComponent } from "./language-convertor/language-translator.component";
import { P404Component } from "../views/error/404/404.component";
import { AngularEditorModule } from "@kolkov/angular-editor";
import { MouseWheelDirective } from "./directive/mouse-wheel.directive";
import { SafePipe } from "./pipe/safe.pipe";
import { LanguageTranslatePipe } from "./pipe/translate.pipe";
import { MultiSelectModule } from "primeng/multiselect";
import { RatingComponent } from "../components/rating/rating.component";
import { AccordionModule } from "primeng/accordion";

import { AngularFireModule } from "@angular/fire";
// for AngularFireAuth
import { NotifierModule, NotifierOptions } from "angular-notifier";
import { AngularFireDatabaseModule } from "@angular/fire/database";
import { AngularFireAuthModule } from "@angular/fire/auth";
import { environment } from "../../environments/environment.prod";
import {DragDropModule} from '@angular/cdk/drag-drop';
import { MessagingService } from "./services/messaging-service";
import { PushNotificationService } from "./services/push-notification.service";
import {FullCalendarModule} from 'primeng/fullcalendar';
import {OverlayPanelModule} from 'primeng/overlaypanel';

const customNotifierOptions: NotifierOptions = {
  position: {
    horizontal: {
      position: "right",
      distance: 12,
    },
    vertical: {
      position: "bottom",
      distance: 12,
      gap: 10,
    },
  },
  theme: "material",
  behaviour: {
    autoHide: 500000,
    onClick: "hide",
    onMouseover: "pauseAutoHide",
    showDismissButton: true,
    stacking: 4,
  },
  animations: {
    enabled: true,
    show: {
      preset: "slide",
      speed: 300,
      easing: "ease",
    },
    hide: {
      preset: "fade",
      speed: 300,
      easing: "ease",
      offset: 50,
    },
    shift: {
      speed: 300,
      easing: "ease",
    },
    overlap: 150,
  },
};

@NgModule({
  declarations: [
    NumberDirective,
    DecimalDirective,
    ControlPasteDirective,
    MouseWheelDirective,
    CurrencySymbolPipe,
    LanguageTranslatePipe,
    SafePipe,
    UserPermissionComponent,
    LanguageTranslatorComponent,
    P403Component,
    P404Component,
    RatingComponent,
  ],
  imports: [
    HttpClientModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    CommonModule,
    ToastrModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    ToastrModule,
    PaginatorModule,
    TableModule,
    CalendarModule,
    CheckboxModule,
    DragDropModule,
    ChartModule,
    AccordionModule,
    ChipsModule,
    DataTableModule,
    DropdownModule,
    NgxSpinnerModule,
    RadioButtonModule,
    DialogModule,
    AgmDirectionModule,
    TooltipModule,
    MultiSelectModule,
    NgbModule,
    FullCalendarModule,
    DragDropModule,
    AngularEditorModule,
    OverlayPanelModule,
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyA6pyIkJXN3Bq-zxTZvd4sEFyEjj2bnCFI",
      libraries: ["places"],
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpBackend],
      },
    }),
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    NotifierModule.withConfig(customNotifierOptions),
    AngularFireMessagingModule
  ],
  entryComponents: [],

  exports: [
    HttpClientModule,
    AppAsideModule,
    AppBreadcrumbModule,
    DragDropModule,
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    BsDropdownModule,
    NgxSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule,
    AccordionModule,
    TabsModule,
    TableModule,
    FullCalendarModule,
    DataTableModule,
    PaginatorModule,
    CalendarModule,
    ChartModule,
    CheckboxModule,
    DropdownModule,
    OverlayPanelModule,
    CommonModule,
    RadioButtonModule,
    ControlPasteDirective,
    MouseWheelDirective,
    DialogModule,
    DecimalDirective,
    NumberDirective,
    CurrencySymbolPipe,
    LanguageTranslatePipe,
    SafePipe,
    AgmCoreModule,
    AgmDirectionModule,
    TooltipModule,
    DragDropModule,
    ChipsModule,
    NgbModule,
    TranslateModule,
    AngularEditorModule,
    MultiSelectModule,
    RatingComponent,
    GMapModule
  ],
  providers: [
    AuthGuard,
    DatePipe,
    PaginationService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    LocalStorageService,
    MessageService,
    MessagingService,
    PushNotificationService
  ],
})
export class SharedModule {}

export function HttpLoaderFactory(handler: HttpBackend) {
  let http = new HttpClient(handler);
  return new TranslateHttpLoader(http);
}
